import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RequestManager = ({ onUpdate }) => {
    const [requests, setRequests] = useState([]);
    const [remark, setRemark] = useState('');
    const [selectedReq, setSelectedReq] = useState(null);

    const fetchRequests = async () => {
        try {
            // Updated to use the admin route defined in updated server.js/adminRoutes.js
            const res = await axios.get('/api/admin/requests');
            setRequests(res.data);
        } catch (err) {
            console.error("Failed to fetch requests", err);
        }
    };

    useEffect(() => { fetchRequests(); }, []);

    const handleDecision = async (id, decision) => {
        if (decision === 'deny' && !remark) {
            alert("Please enter a remark for denial.");
            return;
        }

        try {
            await axios.put(`/api/admin/approve-request/${id}`, { 
                status: decision === 'approve' ? 'APPROVED' : 'REJECTED',
                remark 
            });
            
            setRemark('');
            setSelectedReq(null);
            fetchRequests();
            if (onUpdate) onUpdate(); 
            alert(`Request ${decision === 'approve' ? 'Approved' : 'Denied'}`);
        } catch (err) {
            alert("Error processing request: " + (err.response?.data?.message || err.message));
        }
    };

    const pendingRequests = requests.filter(r => r.status === 'pending');

    return (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="bg-slate-50 px-6 py-4 border-b border-slate-100 flex justify-between items-center">
                <h3 className="font-bold text-slate-700">Pending Requests</h3>
                <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-bold">{pendingRequests.length} Pending</span>
            </div>
            
            <div className="divide-y divide-slate-100">
                {pendingRequests.length === 0 ? (
                    <div className="p-8 text-center text-slate-400 italic">No pending requests found.</div>
                ) : pendingRequests.map(req => {
                    // RESOLVED: Show Email if available, otherwise ID
                    const requester = req.User ? req.User.email : `User ID ${req.userId}`;
                    // RESOLVED: Show Target Name if available, otherwise ID
                    const targetName = req.TargetMember ? req.TargetMember.name : `Member ID ${req.targetMemberId}`;

                    return (
                        <div key={req.id} className="p-6 hover:bg-slate-50 transition">
                            <div className="flex justify-between items-start gap-4">
                                <div>
                                    <div className="flex items-center gap-2 mb-1">
                                        <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-indigo-100 text-indigo-700 uppercase tracking-wide">{req.type}</span>
                                        <span className="text-xs text-slate-400">{new Date(req.createdAt).toLocaleDateString()}</span>
                                    </div>
                                    <p className="text-slate-800 font-medium">
                                        <span className="font-bold text-blue-600">{requester}</span>
                                        {req.type === 'ADD_MEMBER' 
                                        ? ` wants to add "${req.data.name}" to ${targetName}` 
                                        : ` requests phone access for ${targetName}`
                                        }
                                    </p>
                                    {/* Show details for ADD_MEMBER requests */}
                                    {req.type === 'ADD_MEMBER' && (
                                        <div className="mt-2 text-xs text-slate-500 bg-white p-2 border rounded">
                                            <p><strong>Relation:</strong> {req.data.relationshipType}</p>
                                            {req.data.bio && <p><strong>Bio:</strong> {req.data.bio.substring(0, 50)}...</p>}
                                        </div>
                                    )}
                                </div>

                                <div className="flex flex-col gap-2 min-w-[120px]">
                                    <button onClick={() => handleDecision(req.id, 'approve')} className="bg-green-600 text-white px-4 py-1.5 rounded text-sm hover:bg-green-700 shadow-sm transition">
                                        Approve
                                    </button>
                                    {selectedReq === req.id ? (
                                        <div className="animate-fadeIn">
                                            <textarea 
                                                className="border p-2 text-xs rounded w-full h-16 mb-2 outline-none focus:border-red-500" 
                                                placeholder="Reason..." 
                                                value={remark} 
                                                onChange={e => setRemark(e.target.value)} 
                                            />
                                            <div className="flex justify-end gap-2">
                                                <button onClick={() => setSelectedReq(null)} className="text-xs text-gray-500">Cancel</button>
                                                <button onClick={() => handleDecision(req.id, 'deny')} className="bg-red-600 text-white px-2 py-1 rounded text-xs">Confirm</button>
                                            </div>
                                        </div>
                                    ) : (
                                        <button onClick={() => setSelectedReq(req.id)} className="bg-white border border-slate-200 text-slate-600 px-4 py-1.5 rounded text-sm hover:bg-red-50 hover:text-red-600 shadow-sm transition">
                                            Deny
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RequestManager;